import React from "react";
import "./Loader.css";
// import loader from "../../../../assets/logo-scroll.png";
import loader from "../../../../assets/rsto/Le_Logo1.png";

const Loader = () => {
  return (
    <div className="load-content">
      <div className="load-center">
        <div className="ring">
          <span className="load-span"></span>
        </div>
        <div>
          <img className="load-img" src={loader} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
